import { AppBar, Box, Toolbar } from "@mui/material"
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { change } from '../../store/language/languageSlice'


export const Appbar = () => {

    const [language, setLanguage] = useState('spanish')
    const dispatch = useDispatch();
    const [, i18n] = useTranslation('global');

    const translateEnglish = () => {
        i18n.changeLanguage('en');
        dispatch(change())
        setLanguage('english')
    }
    const translateSpanish = () => {
        i18n.changeLanguage('es');
        dispatch(change())
        setLanguage('spanish')
    }

    return (
        <AppBar position="static" color="primary" sx={{ height: '80px', justifyContent: 'center' }}>
            <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                <Box width={130}></Box>
                <img height={48} width={130} src="/logo-navbar.png" alt="logo faraday" />

                {
                    language === 'spanish' &&
                    <Box width={130} display='flex' >
                        <Box width={90}></Box>
                        <img
                            src="/gb.png"
                            width="35"
                            alt="Bandera Reino Unido"
                            onClick={translateEnglish}
                            style={{ cursor: 'pointer' }}
                        />
                    </Box>
                }

                {
                    language === 'english' &&
                    <Box width={130} display='flex'>
                        <Box width={90}></Box>
                        <img
                            src="/es.png"
                            width="33"
                            alt="Bandera España"
                            onClick={translateSpanish}
                            style={{ cursor: 'pointer' }}
                        />
                    </Box>
                }

            </Toolbar>
        </AppBar>
    )
}
